<template>
<div>
  <div class="background-image"><img v-if="bgImage" :src="bgImage">
    <div v-if="title" class="banner text-center">
      <span class="banner-text"><strong>{{title}}</strong></span>
    </div>
  </div>
</div>
</template>

<script>
export default {

  props: {
    title: {
      type: String,
      default: ''
    },
    bgImage: {
      type: String,
      default: null
    }
  },
  data: () => ({
  }),

  computed: {
  },

  methods: {
  }
}
</script>

<style scoped lang="scss">
.banner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(131, 131, 145, 0.55);
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner-text {
  font-family: TimesNewRoman,"Times New Roman",Times,Baskerville,Georgia,serif,serif;
  color: white;
  font-size: 40px;
}
.background-image {
  position: relative;
  text-align: center;
  z-index: 5;
}
</style>